import { useLoader } from 'contexts/LoaderContext';
import Header from './Header';
import Loader from './loaders/SpinnerLoader';
import { Box } from '@newulife/common';
import bgImg from '../../assets/images/somaderm-waterline.jpg';
import AnimatedLoader from './loaders/AnimatedLoader';

export default function Layout({ children }) {
  const { active, animationActive, data } = useLoader();

  return (
    <Box
      sx={{
        color: 'neutralCool.dark',
        height: '100%',
        minHeight: '100vh',
        transition: 'all .2s ease',
        justifyContent: 'flex-start',
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Header />
      {active && <Loader active={active} />}
      {animationActive && <AnimatedLoader active={animationActive} data={data} />}
      {children}
    </Box>
  );
}
